import { useNavigate, useSearch } from '@tanstack/react-router';

import { OfferOverviewTable } from './OfferOverviewTable';
import { tabToOfferStateMap } from './tabToOfferStateMap';
import { useOfferOverviewTotals } from './useOfferOverviewTotals';

export const AdminOfferOverviewTable = () => {
    const search = useSearch({ from: '/_app/offers' });
    const navigate = useNavigate({ from: '/offers' });

    const offerPaginationTotals = useOfferOverviewTotals({
        searchQuery: search.searchQuery,
        supplierIds: search.supplierIds,
        customerIds: search.customerIds,
    });

    const onTabSelect = (tab: string) => {
        navigate({
            search: (previousSearch) => ({
                ...previousSearch,
                tab,
                page: 0,
            }),
        });
    };

    return (
        <OfferOverviewTable
            filters={{
                supplierIds: search.supplierIds,
                customerIds: search.customerIds,
                searchQuery: search.searchQuery,
                states: tabToOfferStateMap[search.tab],
                page: search.page,
                sortField: search.sortValue?.sortField,
                sortDirection: search.sortValue?.sortDirection,
            }}
            selectedTab={search.tab}
            offersTotals={offerPaginationTotals.data ?? {}}
            onTabSelect={onTabSelect}
            onPageChange={(page) => {
                navigate({
                    search: (previousSearch) => ({
                        ...previousSearch,
                        page,
                    }),
                });
            }}
        />
    );
};
